
import BaseRepository from '@/repositories/base/BaseRepository';

class UserRepository extends BaseRepository {
    // 用户
    getLoginUser() {
      return this.get<any>({
        url: '/ebk-dkb-api/ebk-user/get-login-user',
        data: {},
      });
    }  

    // ebk登录提示邮箱配置信息
    queryEbkLoginPromptMailbox() {
      return this.get<any>({
        url: '/ebk-dkb-api/mailbox-configuration/queryEbkLoginPromptMailbox',
        data: {requestFrom:1},
      });
    }

    //换携程token
    getSessionIdByToken(params: any) {
      return this.get<any>({
        url: '/ebk-dkb-api/home/get-session-id-by-token',
        data: params,
      });
    }
   
    //省市
    area() {
      return this.post<any>({
        url: '/ebkcommon/hotelinfo/area',
        data: {},
      });
    } 
    
   // 获取当前登录的酒店信息
   getCurrentHotelInfo() {
      return this.get<any>({
        url: '/ebk-dkb-api/user/get-current-hotel-info',
        data: {},
      });
    }  

    //发送短信验证码
    sendVerifyCode(params:any) {
      return this.post<any>({
        url: '/ebk-dkb-api/home/hecheng/send-verify-code',
        data: params,
      });
    } 
    
    //赫程登录
    generateLoginToken(params:any) {
      return this.post<any>({
        url: '/ebk-dkb-api/home/hecheng/generate-login-token',
        data: params,
      });
    } 
    
  }
  
  export default UserRepository;
  
